import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DrawComplianceDTO } from './draw-compliance.dto';

@Injectable()
export class DrawLottolandComplianceService {
  constructor(private http: HttpClient) {}

  getCompliance(lottoId: number): Observable<DrawComplianceDTO[]> {
    return this.http.get<DrawComplianceDTO[]>('/lottodraw/lottoland-compliance', { params: { lottoId: `${lottoId}` } });
  }

  createDraw(lottolandDrawId: string, lottoId: number): Observable<any> {
    return this.http.post('/lottodraw', { lottolandDrawId, lottoId });
  }
}
